<p>abstract-ng-model works!</p>
